import { render, staticRenderFns } from "./Gdrive.vue?vue&type=template&id=d4c33a86&"
import script from "./Gdrive.vue?vue&type=script&lang=js&"
export * from "./Gdrive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports